import React from 'react'
import usePostArchive from './usePostArchive'

export default function Select ({
  label,
  taxonomy,
  terms
}) {

  const { updateTaxQuery } = usePostArchive()

  if (typeof terms !== 'object' || terms.length === 0) {
    return null
  }

  return (
    <select className="mt-news-archive__filter-container--years" onChange={(e) => updateTaxQuery(taxonomy, e.target.value)}>
      <option value={''}>{label}</option>
      {terms.map((term) => <option
        key={term.id}
        value={term.id}
      >
        {term.name}
      </option>)}
    </select>
  )
}
